export const LogoFull = ({ testid = "navbar-logo", scale = 1 }) => (
  <img
    data-testid={testid}
    src="/assets/mw-logo.png"
    alt="MW Auto Center"
    className="block shrink-0 select-none"
    style={{ width: Math.round(121 * scale), height: "auto" }}
    draggable={false}
  />
);

export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
    <rect width="48" height="48" rx="8" fill="#0A0B0E" />
    <path d="M7 34 L7 14 L16 25 L25 14 L25 34" stroke="#ED1C24" strokeWidth="3.5" strokeLinecap="square" />
    <path d="M28 14 L32 34 L36.5 24 L41 34 L45 14" stroke="#ED1C24" strokeWidth="3.5" strokeLinecap="square" strokeLinejoin="miter" fill="none" />
    <rect x="7" y="39" width="36" height="2.5" fill="#F5D90A" />
  </svg>
);
